module.exports = __webpack_public_path__ + "img/logo_gore-tex@3x.8cb8bd30.png";